<template>
  <div>
    <Head title="客戶級別管理" />
    <ScrollTop />

    <Breadcrumb :home="breadcrumb_home" :model="breadcrumb_paths" />

    <user-level-template>
      <DataTable
        :value="users.data"
        :selection.sync="selectedUsers"
        sortMode="multiple"
        :multiSortMeta.sync="multiSortMeta"
        @sort="onSort($event)"
      >
        <template #header>
          <div class="flex justify-between items-center">
            <div></div>
            <div class="flex flex-row items-center gap-2">
              <span class="p-input-icon-left">
                <i class="pi pi-search" />
                <InputText
                  class="w-52"
                  v-model="search"
                  placeholder="搜尋客戶"
                  @input="onSearch"
                />
              </span>
            </div>
          </div>
        </template>
        <!-- <Column headerClass="w-11" selectionMode="multiple"></Column> -->
        <Column header="姓名" field="name" sortable></Column>
        <Column header="電子郵件" field="email" sortable></Column>
        <Column header="連絡電話" field="mobile" sortable></Column>
        <Column
          v-if="currentType == 'unknown'"
          header="會員類型"
          field="level"
          sortable
        >
          <template #body="slotProps">
            <template v-if="slotProps.data.level == 2">推廣會員</template>
            <template v-else-if="slotProps.data.level == 1">一般會員</template>
            <template v-else-if="slotProps.data.level == -1"
              >一般會員（停用）</template
            >
            <template v-else-if="slotProps.data.level == -2"
              >分潤會員（停用）</template
            >
            <template v-else>{{ slotProps.data.level }}</template>
          </template>
        </Column>

        <Column
          v-if="currentType == 'regular'"
          header="註冊日期"
          field="created_at"
          sortable
        >
          <template #body="slotProps">
            {{ dayjs(slotProps.data.created_at).format("YYYY-MM-DD") }}
          </template>
        </Column>

        <Column
          v-if="currentType == 'qualified'"
          header="達成日期"
          field="attributes.qualified_at"
          sortable
        >
          <template #body="slotProps">
            {{
              dayjs(slotProps.data.attributes.qualified_at).format("YYYY-MM-DD")
            }}
          </template>
        </Column>

        <Column
          v-if="currentType == 'upgraded'"
          header="升級時間"
          field="attributes.upgraded_at"
          sortable
        >
          <template #body="slotProps">
            {{
              dayjs(slotProps.data.attributes.upgraded_at).format("YYYY-MM-DD")
            }}
          </template>
        </Column>

        <Column
          v-if="currentType == 'degraded'"
          header="降級時間"
          field="attributes.degraded_at"
          sortable
        >
          <template #body="slotProps">
            {{
              dayjs(slotProps.data.attributes.upgraded_at).format("YYYY-MM-DD")
            }}
          </template>
        </Column>

        <Column headerClass="w-36" header="動作">
          <template #body="slotProps">
            <SplitButton
              label="詳細"
              :model="splitButonFunction(slotProps.data)"
              @click="viewDetail(slotProps.data.id)"
            ></SplitButton>
          </template>
        </Column>

        <template #empty>沒有任何符合條件的客戶。</template>
      </DataTable>
    </user-level-template>

    <div class="w-full mt-10 flex justify-around">
      <Paginator :page-data="users" />
    </div>
  </div>
</template>

<script>
import Layout from "../Layout";
import ScrollTop from "primevue/scrolltop";
import Breadcrumb from "@/Shared/Components/Breadcrumb";
import UserLevelTemplate from "./Shared/UserLevelTemplate";
import DataTable from "primevue/datatable";
import Dropdown from "primevue/dropdown";
import Column from "primevue/column";
import SplitButton from "primevue/splitbutton";
import InputText from "primevue/inputtext";
import Paginator from "@/Shared/Paginator";

export default {
  layout: Layout,
  components: {
    ScrollTop,
    Breadcrumb,
    UserLevelTemplate,
    DataTable,
    Dropdown,
    Column,
    SplitButton,
    InputText,
    Paginator,
  },
  props: {
    users: Object,
  },
  data() {
    return {
      breadcrumb_home: {
        label: "使用者管理",
        disabled: true,
      },
      breadcrumb_paths: [
        {
          label: "客戶級別管理",
          to: route("admin.users.level"),
          disabled: !decodeURI(this.$page.url).includes("type"),
        },
        {
          label: this.$page.props.breadcrumb_label,
          disabled: true,
        },
      ],
      selectedFilters: [],
      selectedUsers: [],
      multiSortMeta: [],
      search: null,
    };
  },
  computed: {
    currentType() {
      if (decodeURI(this.$page.url).includes("type=qualified")) {
        return "qualified";
      }

      if (decodeURI(this.$page.url).includes("type=regular")) {
        return "regular";
      }

      if (decodeURI(this.$page.url).includes("type=upgraded")) {
        return "upgraded";
      }

      if (decodeURI(this.$page.url).includes("type=degraded")) {
        return "degraded";
      }

      return "unknown";
    },
  },
  methods: {
    // _currentType(type) {
    //   switch (type) {
    //     case "all":
    //       return (
    //         !this.currentType("qualified") &&
    //         !this.currentType("regular") &&
    //         !this.currentType("upgraded") &&
    //         !this.currentType("degraded")
    //       );
    //       break;

    //     default:
    //       return decodeURI(this.$page.url).includes("type=" + type);
    //       break;
    //   }

    //   return false;
    // },
    splitButonFunction(item) {
      // if (this.currentType == "qualified") {
      //   return [
      //     {
      //       label: item.level == 1 ? "升級" : "降級",
      //       command: () =>
      //         this.setLevel(item, item.level == 1 ? "upgrade" : "degrade"),
      //     },
      //   ];
      // }
      return [
        {
          label: item.level == 1 ? "升級" : "降級",
          command: () =>
            this.setLevel(item, item.level == 1 ? "upgrade" : "degrade"),
        },
      ];
    },
    setLevel(item, value) {
      let action = 1;
      switch (value) {
        case "degrade":
          action = 1;
          break;
        case "upgrade":
          action = 2;
          break;
      }

      this.$inertia.post(
        route("admin.users.set_level"),
        {
          id: [item.id],
          action: action,
          from: this.$page.url,
        },
        {
          preserveState: true,
          preserveScroll: true,
        }
      );
    },
    viewDetail(id) {
      this.$inertia.visit(
        route("admin.users.detail", id) +
          "?from=" +
          btoa(encodeURIComponent(this.$page.url))
      );
    },
    getQueryStrings() {
      let queryStr = window.location.search,
        queryArr = queryStr.replace("?", "").split("&"),
        queryParams = [];

      for (let q = 0, qArrLength = queryArr.length; q < qArrLength; q++) {
        let qArr = queryArr[q].split("=");
        queryParams[qArr[0]] = qArr[1];
      }

      return _(queryParams).omitBy(_.isUndefined).omitBy(_.isNull).value();
    },
    onSearch: _.debounce(function () {
      this.selectedOrders = [];

      let queryStringArray = this.getQueryStrings();

      queryStringArray["search"] = this.search;

      let queryStrings = [];

      _.forIn(queryStringArray, (value, key) => {
        queryStrings.push(key + "=" + value);
      });

      let url = this.$page.url.split("?")[0] + "?" + queryStrings.join("&");

      this.$inertia.visit(url, {
        preserveScroll: true,
        preserveState: true,
        only: ["users", "counts"],
      });
    }, 1000),
    onSort(event) {
      this.selectedOrders = [];

      let queryStringArray = this.getQueryStrings();

      queryStringArray["sort"] = JSON.stringify(event.multiSortMeta);

      let queryStrings = [];

      _.forIn(queryStringArray, (value, key) => {
        queryStrings.push(key + "=" + value);
      });

      let url = this.$page.url.split("?")[0] + "?" + queryStrings.join("&");

      this.$inertia.visit(url, {
        preserveScroll: true,
        preserveState: true,
        only: ["merchandises"],
      });
    },
    onFilter(event) {
      this.selectedOrders = [];

      let queryStringArray = this.getQueryStrings();

      queryStringArray["filter"] = JSON.stringify(event.value);

      let queryStrings = [];

      _.forIn(queryStringArray, (value, key) => {
        queryStrings.push(key + "=" + value);
      });

      let url = this.$page.url.split("?")[0] + "?" + queryStrings.join("&");

      this.$inertia.visit(url, {
        preserveScroll: true,
        preserveState: true,
        only: ["merchandises"],
      });
    },
  },
  mounted() {
    if (this.getQueryStrings()["sort"]) {
      this.multiSortMeta = JSON.parse(
        decodeURI(this.getQueryStrings()["sort"])
      );
    }

    if (this.getQueryStrings()["search"]) {
      this.search = decodeURI(this.getQueryStrings()["search"]);
    }

    if (this.getQueryStrings()["filter"]) {
      let selected = JSON.parse(decodeURI(this.getQueryStrings()["filter"]));

      _.forIn(this.filterables, (item) => {
        let found = _.find(selected, item.condition);
        if (found) {
          this.selectedFilters.push(found);
        }
      });
    }
  },
};
</script>

<style lang="postcss">
.p-breadcrumb {
  @apply border-0;
}
</style>